export default __webpack_public_path__ + "static/media/UAE.8c6a463d.svg";